import { render, staticRenderFns } from "./RecommendedCategories.vue?vue&type=template&id=9bdcb3d6"
import script from "./RecommendedCategories.vue?vue&type=script&lang=js"
export * from "./RecommendedCategories.vue?vue&type=script&lang=js"
import style0 from "./RecommendedCategories.vue?vue&type=style&index=0&id=9bdcb3d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VDataTable,VIcon,VSpacer,VSwitch,VTextField})
